import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    main: [],
    auth: []
}

export const MenuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setMain: (state, action) => {
            state.main = action.payload
        },
        delMain: (state) => {
            state.main = []
        },
        setAuth: (state, action) => {
            state.auth = action.payload
        },
        delAuth: (state) => {
            state.auth = []
        }
    },
  })
  
  // Action creators are generated for each case reducer function
  export const { setMain, delMain, setAuth, delAuth } = MenuSlice.actions
  
  export default MenuSlice.reducer